import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  ComponentSelector,
  useVariationIds,
} from '@thd-olt-component-react/component-selector';

import { Hero, HeroFlattenImage, Spotlight } from '..';

const ComponentVariationsPropTypes = {
  id: string,
  variations: arrayOf(shape({})),
  defaultComponent: shape({}),
};

const ComponentVariationsDefaultProps = {
  id: undefined,
  variations: [],
  defaultComponent: {},
};

const mboxes = [
  'contentful-demo-mbox1',
  'contentful-demo-mbox2',
  'contentful-demo-mbox3',
  'contentful-demo-mbox4',
  'hero-mbox-1',
  'hero-mbox-2',
  'hero-mbox-3',
  'hero-mbox-4',
  'spotlight-mbox-1',
  'spotlight-mbox-2',
  'spotlight-mbox-3',
];

export function CustomRenderedComponentVariations({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER_SECTION,
  PLACEHOLDER,

  channel,
}) {
  const { variationIds, renderDefault } = useVariationIds({ mboxes });

  const componentMap = {
    ComponentVariations: ComponentSelector,
    Hero,
    Spotlight: Spotlight({
      SCROLL_BUFFER,
      HOMEPAGE_DELAY_STANDARD,
      PLACEHOLDER,
    }),
    HeroFlattenImage: HeroFlattenImage({
      channel,
    }),
  };

  function ComponentVariations({
    id = '',
    defaultComponent = {},
    variations = [],
  }) {
    return (
      <QueryProvider cacheKey={`componentSelector-${id}`}>
        <ComponentSelector
          defaultComponent={defaultComponent}
          componentMap={componentMap}
          variations={variations || []}
          variationIds={variationIds || []}
          renderDefault={renderDefault}
        />
      </QueryProvider>
    );
  }

  ComponentVariations.propTypes = ComponentVariationsPropTypes;
  ComponentVariations.defaultProps = ComponentVariationsDefaultProps;

  return ComponentVariations;
}
